import React, {Component} from 'react';
import {Field,} from 'redux-form';
import * as Form from '../forms/formFieldHelpers';

const generateYearsForDateSelection = function (startYear) {
    const currentYear = new Date().getFullYear(), years = [];

    startYear = startYear || 1960;

    let key = 1;

    while (startYear <= currentYear) {
        const obj = {};

        obj.id = "" + key;
        obj.name = "" + startYear;
        years.push(obj);
        startYear++;
        key++;
    }
    return years.reverse();
};

const months = [{"id": 1, "name": "January"},
    {"id": 2, "name": "February"},
    {"id": 3, "name": "March"},
    {"id": 4, "name": "April"},
    {"id": 5, "name": "May"},
    {"id": 6, "name": "June"},
    {"id": 7, "name": "July"},
    {"id": 8, "name": "August"},
    {"id": 9, "name": "September"},
    {"id": 10, "name": "October"},
    {"id": 11, "name": "November"},
    {"id": 12, "name": "December"}];

const years = generateYearsForDateSelection();

class DateField extends Component {
    render() {
        return (
            <div className="profile-date">
            <label>Date</label>
                <div className="row">
                <div className="col-xs-12 col-md-4">
                        <div className="new-field-box">
                            <Field
                                label="Month"
                                name="month"
                                placeholder="Select month..."
                                component={ Form.selectField }
                                options={
                                    months.map((selection) => {
                                        return {
                                            value: selection.id,
                                            label: selection.name,
                                        }
                                    })
                                }
                                clearable={ false }
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="new-field-box">
                            <Field
                                label="Year"
                                name="year"
                                placeholder="Select year..."
                                component={ Form.selectField }
                                options={
                                    years.map((selection) => {
                                        return {
                                            value: selection.name,
                                            label: selection.name,
                                        }
                                    })
                                }
                                clearable={ false }
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DateField;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/dates/dateField.js